import * as GroupType from 'constants/GroupType';

const HANDBALL_GROUP_MAP = {};

HANDBALL_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
HANDBALL_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
HANDBALL_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;

export default HANDBALL_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Handball/GroupMap.js